import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { GuidelinesHttpService, GuidelineWithPublishedResponse } from 'guideline/domain';
import { switchMap, tap } from 'rxjs';
import { GuidelineService } from 'shared/domain';

@Injectable()
export class GuidelineReviewUpdateDialogService {
  private guidelineHttpService = inject(GuidelinesHttpService);
  private guidelineService = inject(GuidelineService);

  public loading = signal(false);
  public updateMessage = signal<string | undefined>(undefined);

  public loadGuideline = rxMethod<{ guidelineId: string; updateMessage?: string }>((params$) =>
    params$.pipe(
      tap(() => this.loading.set(true)),
      switchMap(({ guidelineId, updateMessage }) =>
        this.guidelineHttpService.getByIdWithPublished(guidelineId).pipe(
          tapResponse<GuidelineWithPublishedResponse, HttpErrorResponse>(
            ({ latest, published }) => {
              this.guidelineService.setGuideline({ ...latest, updateMessage }, published);
              this.loading.set(false);
            },
            (error) => {
              console.error(error);
              this.loading.set(false);
            },
          ),
        ),
      ),
    ),
  );
}
